(function () {
    'use strict';

    // @ngInject
    function SetupGuideControllerCtor(
        $scope,
        $injector,
        AnalyticsService,
        SetupGuideService,
        UsersManager,
        OnboardingService,
        DeviceService,
        NavigationService,
        $state,
        AppStates
    ) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SetupGuideController';

        this.AnalyticsService = AnalyticsService;
        this.SetupGuideService = SetupGuideService;
        this.UsersManager = UsersManager;

        this.OnboardingService = OnboardingService;

        this.NavigationService = NavigationService;
        this.DeviceService = DeviceService;
        this.$state = $state;
        this.AppStates = AppStates;

        // Update the setup guide page or modal (isSetupGuideModalActive) on setup guide controller
        // and not just on the service. since pretrialers saw the old (page) setup guide.
        this.SetupGuideService.initializeSetupGuideService();

        if (
            this.SetupGuideService.setupGuideType === this.SetupGuideService.setupGuideVersionNames.v4
            && !this.DeviceService.checkIfMobileSize()
        ) {
            this.$state.go(this.AppStates.root_core_navigation_home, { openStreamlinedCard: true });
        }

        // page load, appears on the directives.
        //this.AnalyticsService.trackPageView(this, 'setup guide');

        // curr user
        this.user = this.UsersManager.getCurrUser();

        this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.introPanels);

    }

    Controllers.SetupGuideController = Class(Controllers.BaseController, {
        constructor: SetupGuideControllerCtor,


        handleCloseDarkSetupGuide: function handleCloseDarkSetupGuide() {
            this.closeSetupGuideModal();
        },

        handleCloseSetupGuideStreamlined: function handleCloseSetupGuideStreamlined() {
            this.closeSetupGuideModal();
        },

        closeSetupGuideModal: function closeSetupGuideModal() {
           var dontCloseToTheseStates = [
               this.AppStates.root_core_onboardingInvoiceV2CreationBrand,
               this.AppStates.root_core_onboardingInvoiceV2CreationStart,
               this.AppStates.root_core_onboardingInvoiceV2CreationPackage,
               this.AppStates.root_core_workspaceFile,
               this.AppStates.root_core_workspaceFileRedirection,
               this.AppStates.root_core_workspaceFile_stepProposal,
               this.AppStates.root_core_workspaceFile_stepAgreement,
               this.AppStates.root_core_workspaceFile_stepPayment,
               this.AppStates.root_core_workspaceFile_stepQuestionnaire,
               this.AppStates.root_core_workspaceFile_brochure,
               this.AppStates.root_core_workspaceFile_timeline,
               this.AppStates.root_core_accountSetup
           ];

            this.SetupGuideService.animateSetupGuideTopNavAfterClose();

            var previous = this.$state.previous;
            if (previous && _.contains(dontCloseToTheseStates, previous.route.name)){
                //go to home.
                this.$state.go(this.AppStates.root_core_navigation_home)
            } else {
                this.NavigationService.goHistoryBack();
            }
        }

    });
}());
